import { render, staticRenderFns } from "./Facebook.vue?vue&type=template&id=66c41b11&scoped=true&"
import script from "./Facebook.vue?vue&type=script&lang=ts&"
export * from "./Facebook.vue?vue&type=script&lang=ts&"
import style0 from "./Facebook.vue?vue&type=style&index=0&id=66c41b11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c41b11",
  null
  
)

export default component.exports